import { render, staticRenderFns } from "./assignments-skills.vue?vue&type=template&id=75cd9a12"
import script from "./assignments-skills.vue?vue&type=script&lang=js"
export * from "./assignments-skills.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports